import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarClient"] */ "/vercel/path0/src/components/layout/NavbarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExamEventPopup"] */ "/vercel/path0/src/components/marketing/ExamEventPopup.tsx");
